import BaseTemplate from '../../components/baseTemplate';
import { useDispatch } from 'react-redux';
import { useLocalization } from 'src/utils/useLocalization';
import { USER_ACTIONS } from '../../../../utils/enums/user-store-actions.enum';

import './styles.scss';

const LockedAccount = () => {
    const { labelTitle, labelText } = useLocalization();
    const userDispatch = useDispatch();

    const homePage = () => {
        userDispatch({ type: USER_ACTIONS.SET_BLOCKED, payload: false });
    };

    return (
        <BaseTemplate>
            <div className={'form-wrapper'}>
                <div className={'lockedaccount-form'}>
                    <div className={'header u-mb-large'}>
                        <h4>{labelTitle.LABEL_TITLE_LOCKED_ACCOUNT}</h4>
                    </div>
                    <div className={'info-section'}>
                        <p>{labelText.LABEL_TEXT_ACCOUNT_LOCKED}</p>
                        <p className={'highligthed'}>
                            {labelText.LABEL_TEXT_ACCOUNT_CONTACT}
                        </p>
                        <p>{labelText.LABEL_TEXT_OR}</p>
                        <div className={'highligthed u-pb-xxsmall'}>
                            {labelText.LABEL_TEXT_ACCOUNT_BRAND}
                        </div>
                        <div className={'phone-number u-pb-xxsmall'}>
                            {labelText.LABEL_TEXT_ACCOUNT_PHONE}
                        </div>
                        <div>{labelText.LABEL_TEXT_ACCOUNT_HOURS}</div>
                        <div>{labelText.LABEL_TEXT_ACCOUNT_WEEKEND_HOURS}</div>
                    </div>
                    <div className={'link-section'}>
                        <a onClick={homePage}>
                            {labelText.LABEL_TEXT_ACCOUNT_LINK}
                        </a>
                    </div>
                </div>
            </div>
        </BaseTemplate>
    );
};

export default LockedAccount;
